/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Tooling = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    id="bd8e41e0-d1ef-4799-9ef5-c3559267c7a6"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <defs>
      <style>
        {
          ".ba7c87bb-97b6-404a-9a83-379530834602{stroke:#3f20ba;stroke-linejoin:round;stroke-width:.5px}.b90bd33f-2fd1-432c-be41-94039068474d,.ba7c87bb-97b6-404a-9a83-379530834602{fill:#d9cfff}.bc26b56a-923d-4cf3-98bd-693ab24af86b{fill:#3f20ba}"
        }
      </style>
    </defs>
    <path
      fill="#fff"
      stroke="#3f20ba"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M22.59 14.92L10.86 8.15a1.87 1.87 0 0 0 .14-.73c0-1.63-2.29-3-5.12-3A8.36 8.36 0 0 0 4 4.68l3 1.71A.82.82 0 0 1 7 7.8l-.42.2a2.42 2.42 0 0 1-2.44 0l-3-1.71A2 2 0 0 0 .8 7.42c0 1.63 2.29 3 5.12 3a8.85 8.85 0 0 0 1.29-.11L19 17a3.64 3.64 0 0 0 3.64 0h0a1.22 1.22 0 0 0-.05-2.08z"
    />
    <path
      d="M22.6 17a3.64 3.64 0 0 1-3.6 0L7.21 10.27a8.85 8.85 0 0 1-1.29.11C3.09 10.38.8 9.05.8 7.42v2c0 1.63 2.29 3 5.12 3a7.65 7.65 0 0 0 1.29-.11L19 19.05a3.64 3.64 0 0 0 3.64 0 1.2 1.2 0 0 0 .6-1v-2a1.19 1.19 0 0 1-.64.95zM6.58 8L7 7.8a.82.82 0 0 0 0-1.41L4 4.68v2l2.42 1.4z"
      className="ba7c87bb-97b6-404a-9a83-379530834602"
    />
    <path
      d="M7.21 10.27l2.36-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M7.09 10.05l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M8.08 10.77l2.36-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M7.96 10.55l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M8.95 11.27l2.35-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M8.82 11.05l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M9.81 11.77l2.36-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M9.69 11.55l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M10.68 12.27l2.35-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M10.55 12.05l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M11.54 12.77l2.36-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M11.42 12.55l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M12.41 13.27l2.36-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M12.29 13.05l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M13.28 13.77l2.35-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M13.15 13.55l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M14.14 14.27l2.36-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M14.02 14.05l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M15.01 14.77l2.35-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M14.88 14.55l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M15.87 15.27l2.36-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M15.75 15.05l2.48-1.14L16 15.48l-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M16.74 15.77l2.36-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M16.61 15.55l2.49-1.14-2.24 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M17.61 16.27l2.35-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M17.48 16.05l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M18.47 16.77l2.36-1.36"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M18.35 16.55l2.48-1.14-2.23 1.57-.25-.43z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
    <path
      d="M19.37 17.25l2.32-1.34"
      className="b90bd33f-2fd1-432c-be41-94039068474d"
    />
    <path
      d="M19.24 17.03l2.45-1.12-2.2 1.56-.25-.44z"
      className="bc26b56a-923d-4cf3-98bd-693ab24af86b"
    />
  </svg>
));
